import React, { useEffect, useState } from 'react';
import { WithControllerInjectedProps, withController } from 'react-scroll-parallax';
import { formatMessage } from '@99designs/frontend-components/i18n';
import Attribution from '../../../../shared/components/Attribution';
import { CategoryType, EntryType } from '../ContestOverviewData';
import Entry from './Entry';
import StyledEntries from './StyledEntries';

export interface Props extends WithControllerInjectedProps {
    entries?: EntryType[];
    category: CategoryType;
    withLargeStats?: boolean;
}

function ContestEntries({ entries, category, parallaxController, withLargeStats = false }: Props) {
    const entriesToShow = entries ? entries : Array(6).fill({});
    const [enableParallax, setEnableParallax] = useState(false);
    const [isIE11, setIsIE11] = useState(false);

    useEffect(() => {
        const isIE11 = !!(window as any).msCrypto; // Only available in IE11, see https://developer.mozilla.org/en-US/docs/Web/API/Window/crypto
        const enableParallax = window.document.documentElement.clientWidth > 899 && !isIE11;

        setIsIE11(isIE11);
        setEnableParallax(enableParallax);

        if (!enableParallax) {
            // Ensure parallaxController updates on load due to browser scroll issues
            // https://github.com/jscottsmith/react-scroll-parallax/issues/63#issuecomment-507133465
            window.addEventListener('load', () => {
                parallaxController.update();
            });
        }
    }, []);

    return (
        <StyledEntries asPlaceholders={!entries} withLargeStats={withLargeStats} isIE11={isIE11}>
            {entriesToShow.map((entry, index) => {
                let src, alt, attribution;

                if (entry.designUrl) {
                    src = entry.designUrl;
                    attribution = <Attribution name={entry.designer.displayName} />;
                    alt = formatMessage(__('{categoryTitle} contest entry by {designerName}'), {
                        categoryTitle: category.title,
                        designerName: entry.designer.displayName,
                    });
                }

                return (
                    <Entry
                        src={src}
                        alt={alt}
                        attribution={attribution}
                        parallax={enableParallax}
                        index={index}
                        key={index}
                    />
                );
            })}
        </StyledEntries>
    );
}

export default withController(ContestEntries);
